import Vue from "vue";
import _ from "lodash";
import MqttClient from "@/components/mqtt-client";
import { EventBus } from "@/event-bus";

const MQTT_CLIENT_ID_MAX_LENGTH = 23;

export default Vue.component("mqtt-manager", {
	props: {
		reconnect: { type: Boolean, default: false }
	},
	computed: {
		mqttCredentials() {
			return this.$store.getters.mqttCredentials;
		},
		username() {
			return this.$store.state.user.username;
		},
		subscriptions() {
			return this.$store.getters.mqttSubscriptions;
		}
	},
	beforeMount() {},
	mounted() {},
	methods: {
		generateRandomClientID() {
			// TODO: solve the race condition of not yet having a username
			return (
				"tfmwdm-" + // TerraForm Manager Web Device Manager
				this.username.substring(0, 14) +
				"-" +
				(Math.random() * 1000000000000000).toString()
			).substring(0, MQTT_CLIENT_ID_MAX_LENGTH);
		}
	},
	render(h) {
		const manager = this;
		return h(
			"div",
			{ class: "mqtt-manager" },
			_.isEmpty(this.username)
				? []
				: _.map(this.mqttCredentials, (c, k) => {
						return h(
							MqttClient,
							{
								ref: k,
								on: {
									["mqtt-client:messageArrived"](message) {
										EventBus.pushGlobalEvent("mqtt-client:messageArrived", {
											client: manager.$refs[k],
											message
										});
									},
									["mqtt-client:subscribed"](message) {
										EventBus.pushGlobalEvent("mqtt-client:subscribed", {
											client: manager.$refs[k],
											message
										});
									},
									["mqtt-client:connectFailed"]({ client, message }) {
										EventBus.pushGlobalEvent("mqtt-client:connectFailed", {
											client,
											message
										});
									},
									["mqtt-client:connectionLost"]({ client, message }) {
										EventBus.pushGlobalEvent("mqtt-client:connectionLost", {
											client,
											message
										});
									},
									["mqtt-client:isConnected"]({ client, isConnected }) {
										EventBus.pushGlobalEvent("mqtt-client:isConnected", {
											client,
											isConnected
										});
									}
								},
								props: Object.assign({}, c, {
									clientId: this.generateRandomClientID(),
									subscriptions: Object.assign({}, this.subscriptions),
									reconnect: this.reconnect
								})
							},
							[]
						);
				  })
		);
	}
});
